<template>
  <div class="choice-abc">
    <span class="form_select-default">
      <select
        v-model="selectedDay"
        class="form_select form_select_regular_day"
        title="정기 결제일을 선택하세요"
        @change="$emit('input', $event.target.value)"
      >
        <option value="" selected="selected">선택</option>
        <option v-for="day in days" :key="day" :value="day" class="chk_day">
          {{ day }}일
        </option>
      </select>
      <div class="form_select_desc" :style="{ display: formattedDate ? 'block' : 'none' }">
        첫 정기결제 예정일은 <span>{{ formattedDate }}</span> 입니다.
      </div>
    </span>
    <ul>
      <li class="choice_disc">
        <i></i>결제일 지정은 A Pay 자동이체, A Pay 카드 결제, 카드 결제,
        자동이체의 경우 2일부터 27일까지만 가능합니다.
      </li>
      <li class="choice_disc">
        <i></i>정기구매는 배달수령만 가능하며, 제품의 단종 및 재고상황에 따라
        주문이 취소 될 수 있습니다.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BillingDateSelection",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      days: Array.from({ length: 26 }, (_, i) => i + 2),
      selectedDay: this.value,
      today: new Date(),
    };
  },
  computed: {
    nextBillingDate() {
      if (!this.selectedDay) return null;

      const today = this.today;
      const year = today.getFullYear();
      const month = today.getMonth();
      const date = today.getDate();

      let nextYear = year;
      let nextMonth = month;
      let nextDay = this.selectedDay;

      // 선택한 결제일이 오늘보다 작으면 다음 달로 설정
      if (nextDay <= date) {
        nextMonth += 1;
        if (nextMonth > 11) {
          // 12월을 넘어가면 다음 해로
          nextMonth = 0;
          nextYear += 1;
        }
      }

      return new Date(nextYear, nextMonth, nextDay);
    },
    formattedDate() {
      if (!this.nextBillingDate) return "";

      const date = this.nextBillingDate;
      const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
      const dayOfWeek = daysOfWeek[date.getDay()];

      return `${date.getFullYear()}년 ${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}월 ${String(date.getDate()).padStart(2, "0")}일 (${dayOfWeek})`;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/composition/main/step3/BillingDateSection.vue